import { render, staticRenderFns } from "./RawLeads.vue?vue&type=template&id=bb7b7afa&"
import script from "./RawLeads.vue?vue&type=script&lang=js&"
export * from "./RawLeads.vue?vue&type=script&lang=js&"
import style0 from "./RawLeads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports